    function initializeCollectionTabSwitching() 
    {
        document.querySelectorAll('.collection-tab-link').forEach(function(tab) 
        {
            tab.addEventListener('click', function() 
            {
                document.querySelectorAll('.collection-tab-link').forEach(function(t) 
                {
                    t.classList.remove('active');
                });
                document.querySelectorAll('.collection-tab-content').forEach(function(content) 
                {
                    content.classList.remove('active');
                });
                tab.classList.add('active');
                document.getElementById(tab.getAttribute('data-collection-tab')).classList.add('active');

                $('.mens-slider, .womens-slider').slick('setPosition');
            });
        });
    }

    function initializeProductTabSwitching() 
    {
        document.querySelectorAll('.product-tab-link').forEach(function(tab) 
        {
            tab.addEventListener('click', function() 
            {
                document.querySelectorAll('.product-tab-link').forEach(function(t) 
                {
                    t.classList.remove('active');
                });
                document.querySelectorAll('.product-tab-content').forEach(function(content) 
                {
                    content.classList.remove('active');
                });
                tab.classList.add('active');
                document.getElementById(tab.getAttribute('data-product-tab')).classList.add('active');

                $('.mens-products-slider, .womens-products-slider').slick('setPosition');
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() 
    {
        initializeCollectionTabSwitching();
        initializeProductTabSwitching();
    });

    $(document).ready(function()
    {
        $('.mens-slider').on('init', function(event, slick)
        {
            $(this).css('visibility', 'visible');
        }).slick(
        {
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        $('.womens-slider').on('init', function(event, slick)
        {
            $(this).css('visibility', 'visible');
        }).slick(
        {
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        $('.mens-products-slider').on('init', function(event, slick)
        {
            $(this).css('visibility', 'visible');
        }).slick(
        {
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });

        $('.womens-products-slider').on('init', function(event, slick)
        {
            $(this).css('visibility', 'visible');
        }).slick(
        {
            slidesToShow: 4,
            slidesToScroll: 4,
            nextArrow: '<button type="button" class="slick-next"></button>',
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        });
    });